import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Routes from './Routes';
import { withRouter } from 'react-router';

class Navigator {
  constructor({ match, location, history }) {
    this.match = match;
    this.location = location;
    this.history = history;
  }

  navigateHandlerFor = route => () => this.history.push(route);
  navigateBack = () => this.history.goBack();
  navigateHome = this.navigateHandlerFor(Routes.home);
}

const withNavigator = ComponentToWrap => {
  class NavigatorComponent extends Component {
    static propTypes = {
      history: PropTypes.object,
      location: PropTypes.object,
      match: PropTypes.object
    };

    render() {
      const { history, location, match } = this.props;
      const navigator = new Navigator({ match, location, history });
      return <ComponentToWrap {...this.props} navigator={navigator} />;
    }
  }

  return withRouter(NavigatorComponent);
};

export default withNavigator;
